import React, { FunctionComponent } from "react"
import {
    FormControl,
    Grid,
    FormLabel,
    Tooltip,
    Typography,
    FormHelperText
} from "@material-ui/core"
import InfoIcon from "@material-ui/icons/Info"
import styles from "./FieldContainer.module.scss"

interface FieldContainerProps {
    label: string
    info?: string
    error?: string
    className?: string
    variant?: "standard" | "outlined" | "filled"
}
export const FieldContainer: FunctionComponent<FieldContainerProps> = ({
    label,
    info,
    error,
    className,
    variant = "outlined",
    children
}) => (
    <FormControl
        id={`${label.replace(" ", "-").toLowerCase()}-field-control`}
        className={className ?? ""}
        margin="dense"
        variant={variant}
        fullWidth
    >
        <Grid item container direction="row" spacing={1}>
            <Grid item>
                <FormLabel id={`${label.replace(" ", "-").toLowerCase()}-field-label`}>
                    {label}
                </FormLabel>
            </Grid>
            <Grid item>
                {info && (
                    <Tooltip
                        placement="left"
                        title={<Typography variant="caption">{info}</Typography>}
                    >
                        <InfoIcon color="primary" />
                    </Tooltip>
                )}
            </Grid>
        </Grid>
        {children}
        <Grid item>
            <FormHelperText
                className={styles.FieldContainer__errorText}
                error
                data-testid={`${label.replace(" ", "-").toLowerCase()}-field-error`}
            >
                {error}
            </FormHelperText>
        </Grid>
    </FormControl>
)
